import { FaCheck } from 'react-icons/fa6';
import SlidingModal from '@/components/home/mobile/SlidingModal';
export default function OrderTypeModal({
  isModalOpen,
  toggleModal
}) {
  const liClass = 'h-[52px] items-center flex';
  const soonClass = 'bg-genius-blue text-[10px] rounded-xl px-2 ml-2 font-light px-1';
  return <SlidingModal heightFit={true} isOpen={isModalOpen} onClose={toggleModal} data-sentry-element="SlidingModal" data-sentry-component="OrderTypeModal" data-sentry-source-file="OrderTypeModal.tsx">
      <div className='pb-0 bg-genius-indigo text-sm ta-l text-genius-cream w-full mt-2'>
        <ul>
          <li className={`flex items-center pl-4 bg-genius-blue ${liClass}`}>
            {' '}
            <FaCheck className='mr-4' data-sentry-element="FaCheck" data-sentry-source-file="OrderTypeModal.tsx" /> One Time Order
          </li>
          <li className={`${liClass} pl-12`}>
            Recurring Order <span className={`${soonClass}`}>Soon!</span>
          </li>
          <li className={`${liClass} pl-12`}>
            Limit Order<span className={`${soonClass}`}>Soon!</span>
          </li>
          <li className={`${liClass} pl-12`}>
            Take Profit<span className={`${soonClass}`}>Soon!</span>
          </li>
          <li className={`${liClass} pl-12`}>
            Stop Loss <span className={`${soonClass}`}>Soon!</span>
          </li>
        </ul>
      </div>
    </SlidingModal>;
}